// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8550 ? "ed48eaa7" : chunkId) + "." + {"5084":"7595c060056cbf9c","8550":"160ce76de0484837","9836":"27ded3f3c93dbd82"}[chunkId] + ".js";
};